module.exports = __webpack_public_path__ + "890f23b1de3839758e9c0eec971a6a34.svg";